import type { SessionCard, SessionTask } from '../type';

/**
 * Id alapjan megkeresi a task-t
 */
export function findTaskById(
  taskId: SessionTask['id'],
  cards: SessionCard[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  caller: string,
): SessionTask | undefined {
  const task = cards.flatMap(({ tasks }) => tasks ?? []).find(({ id }) => id === taskId);
  if (task === undefined) {
    // TODO majd elesitesnel vissza lehet rakni? de lehet elotte atgondolni mert false jelzesnek vesszuk neha :(
    // console.error(`[SessionState::${caller}] Not found task! => ${taskId}`);
  }

  return task;
}
